import { useSubjectFilterOptions } from "@/store/selectors";
import { FilterOptionChip } from "../AdvizerSearchFilters";
import { ResourceConfigs } from "@/configs/resourceConfigs";
import { Group, Stack } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { TextInput } from "../ui/TextInput";
import { IconSearch } from "@tabler/icons-react";
import { useIsLaptopOrBigger } from "@/styles/useStyles";
import { UserProfileService } from "@/services/UserProfileService";
import { useUserSubjects } from "@/store/selectors/userProfileSelectors";
import { Analytics } from "@/services/Analytics";
import { useActivePlaylist } from "@/store/selectors/playlistSelectors";

export const PlaylistMajorSelector = () => {
  const { subjects } = useSubjectFilterOptions();
  const [search, setSearch] = useState("");
  const isLaptopOrBigger = useIsLaptopOrBigger();
  const userSubjects = useUserSubjects();
  const activePlaylist = useActivePlaylist();
  const filteredSubjects = useMemo(() => {
    return subjects.filter((subject) =>
      subject.title.toLowerCase().includes(search.toLowerCase()),
    );
  }, [subjects, search]);

  const handleSelectSubject = (option: any) => {
    const alreadySelected = userSubjects?.[option.id];
    if (alreadySelected) {
      UserProfileService.removeSubject({ id: option.id });
    } else {
      UserProfileService.addSubject({
        id: option.id,
        title: option.label,
      });

      Analytics.updateUserProfile({
        action: "add_subject",
        label: option.label,
        playlist: activePlaylist,
      });
    }
  };

  useEffect(() => {
    // loop through user subjects and if id is not in subjects then remove it
    Object.keys(userSubjects).forEach((slug) => {
      if (!subjects.some((s) => s.slug === slug)) {
        UserProfileService.removeSubject({ id: slug });
      }
    });
  }, [subjects, userSubjects]);

  return (
    <Stack align="center" w="100%">
      <TextInput
        id="partnerSearchInput"
        title="Search for major"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search"
        size={isLaptopOrBigger ? "sm" : "md"}
        radius="xl"
        leftSection={<IconSearch size={18} />}
        maw={350}
        w="100%"
      />

      {/* <Space h="xs" /> */}

      <Group justify="flex-start" gap="xs" maw={600}>
        {filteredSubjects.map((subject) => {
          return (
            <FilterOptionChip
              key={subject.slug}
              size={isLaptopOrBigger ? "sm" : "sm"}
              checked={userSubjects?.[subject.slug]}
              tab={{
                value: "subject",
                filterKey: "subjects",
                onClick: (option) => {
                  handleSelectSubject(option);
                  // setSelectedSubjects((prev) => {
                  //   if (prev.includes(option.id)) {
                  //     return prev.filter((id) => id !== option.id);
                  //   }
                  //   return [...prev, option.id];
                  // });
                },
              }}
              option={{ id: subject.slug, label: subject.title }}
              resourceConfig={ResourceConfigs.subject}
            />
          );
        })}
      </Group>
    </Stack>
  );
};
